<template>
  <div class="w-full break-inside-avoid">
    <div class="card rounded-lg shadow-lg bg-gray-100 animate-pulse">
      <div class="flex flex-row w-full h-48 md:h-40 min-h-[12rem]">
        <!-- Image/Map skeleton -->
        <div class="hidden lg:block w-1/4 h-full shrink-0 bg-gray-300 rounded-l-lg"></div>
        
        <!-- Content skeleton -->
        <div class="flex flex-col flex-1 px-6 py-6 justify-between">
          <div class="space-y-4">
            <!-- Title skeleton -->
            <div class="h-6 bg-gray-300 rounded w-3/4"></div>
            
            <!-- Distance/Address skeleton -->
            <div class="space-y-2">
              <div class="h-4 bg-gray-300 rounded w-1/2"></div>
              <div class="h-4 bg-gray-300 rounded w-2/3"></div>
            </div>
            
            <!-- Description skeleton -->
            <div class="space-y-2">
              <div class="h-3 bg-gray-300 rounded w-full"></div>
              <div class="h-3 bg-gray-300 rounded w-4/5"></div>
            </div>
          </div>
          
          <!-- Bottom section skeleton -->
          <div class="flex justify-between items-center">
            <div class="h-4 bg-gray-300 rounded w-20"></div>
            <div class="h-8 bg-gray-300 rounded-full w-24"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  background: #f9fafb;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>